<template>
    <div class="status-type-icon">
        <i :class="[statusClass, statusIcon]"></i>
    </div>
</template>

<script>
export default {
    components: {},

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        statusType: {
            default: null,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        statusIcon() {
            if (this.statusType == 'high') {
                return 'icon-cross-with-circle'
            }
            if (this.statusType == 'medium') {
                return 'icon-cross-with-circle'
            }
            if (this.statusType == 'low') {
                return 'icon-cross-with-circle'
            }
            if (this.statusType == 'sanction') {
                return 'icon-cross-with-circle'
            }
            if (this.statusType === false) {
                return 'icon-tick-with-circle'
            }
            if (this.statusType === 'false') {
                return 'icon-tick-with-circle'
            }
            return 'icon-check-circle'
        },
        statusClass() {
            if (this.statusType === true) {
                return 'ok-level'
            }
            if (this.statusType === false) {
                return 'pending'
            }
            if (this.statusType === 'false') {
                return 'pending'
            }
            if (this.statusType == 'sanction') {
                return 'black'
            }
            if (this.statusType == 'high') {
                return 'danger'
            }
            if (this.statusType == 'medium') {
                return 'danger'
            }
            if (this.statusType == 'low') {
                return 'danger'
            }

            return 'pending'
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {}, // End of Component > mounted
} // End of export default
</script>
